import { render, staticRenderFns } from "./MinisitePaylink.vue?vue&type=template&id=032daab4&"
import script from "./MinisitePaylink.vue?vue&type=script&lang=js&"
export * from "./MinisitePaylink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports